// extracted by mini-css-extract-plugin
module.exports = {"disclaimer__wrp":"_2jX4KadUEKUi","disclaimer_columnContent":"IMwRFyBqg4_Z","disclaimer":"msVbajn6XRPB","disclaimer__icon_info":"MO9ZW_usk9CA"};